import { IS_SERVER } from "@/constants";
import { useBrandContext } from "@/shared/contexts";
import { useTrackingEvent } from "./useTrackingEvent";
export const useTrackingProductClick = (partnerName) => {
    var _a, _b;
    const priceLinkPartner = ((_b = (_a = useBrandContext()) === null || _a === void 0 ? void 0 : _a.partnerService) !== null && _b !== void 0 ? _b : []).find((service) => service.name === partnerName);
    if (priceLinkPartner)
        priceLinkPartner.pageViewGA4.av_url_path = !IS_SERVER
            ? window.location.pathname
            : "";
    const EVENT_DATA = {
        type: "product",
        description: "click",
        infos: "partnerbox-ads",
        ...priceLinkPartner === null || priceLinkPartner === void 0 ? void 0 : priceLinkPartner.pageViewGA4,
        products: [],
    };
    // TODO: Check the interface, should this be actually GA3?
    const thorEvent = useTrackingEvent(EVENT_DATA);
    // don't call function thorEvent if priceLinkPartner is not set
    if (!priceLinkPartner)
        return () => { };
    return () => thorEvent();
};
